<template>
  <div>
    <Nav></Nav>
    <b-container fluid="xl">
      <b-row class="mt-3">
        <b-col><h1>Configuración → Canales y modalidades</h1></b-col>
      </b-row>

      <!-- Catálogo global (solo lectura) -->
      <b-row class="mt-3">
        <b-col>
          <h4>Canales y modalidades (catálogo global)</h4>
          <b-table small striped :items="catalog" :fields="catalogFields"></b-table>
        </b-col>
      </b-row>

      <!-- Área → modalidad -->
      <b-row class="mt-4">
        <b-col>
          <h4>Modalidad por área</h4>
          <p class="text-muted">La modalidad por defecto que hereda el ticket cuando se cierra en esa área.</p>
          <b-table small striped hover responsive :items="areas" :fields="areaFields" :busy="loadingAreas">
            <template #cell(fulfillment_code)="data">
              <b-form-select
                v-model="data.item.fulfillment_code"
                :options="fulfillmentOptions"
                size="sm"
                style="max-width: 220px;">
              </b-form-select>
            </template>
            <template #cell(buttons)="data">
              <b-button size="sm" variant="warning" @click="saveArea(data.item)">Guardar</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <!-- Región + QR por sucursal -->
      <b-row class="mt-4">
        <b-col>
          <h4>Región y QR de descarga por sucursal</h4>
          <b-table small striped hover responsive :items="sucursals" :fields="sucursalFields" :busy="loadingSucursals">
            <template #cell(region)="data">
              <b-form-input v-model="data.item.region" size="sm" style="max-width: 220px;"></b-form-input>
            </template>
            <template #cell(qr)="data">
              <div v-if="data.item.qr_token">
                <small><code>{{ qrUrl(data.item.qr_token) }}</code></small>
              </div>
              <b-button size="sm" variant="outline-secondary" @click="regenToken(data.item)">
                {{ data.item.qr_token ? 'Regenerar token' : 'Generar token' }}
              </b-button>
            </template>
            <template #cell(buttons)="data">
              <b-button size="sm" variant="warning" @click="saveSucursal(data.item)">Guardar</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Nav from "../../components/Nav.vue";
import restaurantAreaService from "../../services/restaurantAreaService";
import sucursalService from "../../services/sucursalService";
import featuresService from "../../services/featuresService";

export default {
  name: "canales-modalidades",
  components: { Nav },
  data() {
    return {
      catalog: [
        { etiqueta: "App", channel_code: "app", fulfillment_code: "delivery, dinein" },
        { etiqueta: "Pickup", channel_code: "app", fulfillment_code: "pickup" },
        { etiqueta: "Para llevar", channel_code: "pos", fulfillment_code: "takeaway" },
        { etiqueta: "Salón", channel_code: "pos", fulfillment_code: "dinein" },
        { etiqueta: "Taquizas", channel_code: "taquiza", fulfillment_code: "event" },
        { etiqueta: "Uber / Rappi / PideDirecto", channel_code: "uber / rappi / pidedirecto", fulfillment_code: "delivery" },
      ],
      catalogFields: [
        { key: "etiqueta", label: "Etiqueta" },
        { key: "channel_code", label: "channel_code" },
        { key: "fulfillment_code", label: "fulfillment_code" },
      ],
      fulfillmentOptions: [
        { value: "dinein", text: "Salón (dinein)" },
        { value: "takeaway", text: "Para llevar (takeaway)" },
        { value: "delivery", text: "Domicilio (delivery)" },
        { value: "pickup", text: "Pickup" },
        { value: "event", text: "Evento" },
      ],
      areas: [],
      loadingAreas: true,
      areaFields: [
        { key: "id", label: "ID" },
        { key: "name", label: "Área" },
        { key: "fulfillment_code", label: "Modalidad" },
        { key: "buttons", label: "" },
      ],
      sucursals: [],
      loadingSucursals: true,
      sucursalFields: [
        { key: "id", label: "ID" },
        { key: "nombre", label: "Sucursal" },
        { key: "region", label: "Región" },
        { key: "qr", label: "QR de descarga" },
        { key: "buttons", label: "" },
      ],
      qrBaseUrl: "https://app.eltizoncito.com.mx/r",
    };
  },
  mounted() {
    this.loadAreas();
    this.loadSucursals();
    this.loadQrBase();
  },
  methods: {
    loadAreas() {
      this.loadingAreas = true;
      restaurantAreaService
        .getAll()
        .then((res) => {
          this.areas = (res.data || []).map((a) => ({ ...a, fulfillment_code: a.fulfillment_code || "dinein" }));
        })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"))
        .finally(() => (this.loadingAreas = false));
    },
    loadSucursals() {
      this.loadingSucursals = true;
      sucursalService
        .getAll()
        .then((res) => {
          this.sucursals = (res.data || []).map((s) => ({
            ...s,
            region: (s.region && s.region.String !== undefined) ? s.region.String : (s.region || ""),
            qr_token: (s.qr_token && s.qr_token.String !== undefined) ? s.qr_token.String : (s.qr_token || ""),
          }));
        })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"))
        .finally(() => (this.loadingSucursals = false));
    },
    loadQrBase() {
      featuresService.getAll().then((res) => {
        const f = res.data && res.data.features && res.data.features["attribution.capture"];
        if (f && f.config && f.config.qr_base_url) this.qrBaseUrl = f.config.qr_base_url;
      }).catch(() => {});
    },
    saveArea(area) {
      restaurantAreaService
        .update(area.id, area)
        .then(() => this.makeToast("Guardado", "Modalidad de " + area.name + " actualizada", "success"))
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    regenToken(suc) {
      // Persiste el token de inmediato con el endpoint dedicado (no requiere "Guardar").
      sucursalService.regenerateQr(suc.id)
        .then((res) => {
          this.$set(suc, "qr_token", res.data.qr_token);
          this.makeToast("Listo", "Token regenerado y guardado", "success");
        })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    saveSucursal(suc) {
      // El backend espera el objeto completo con el id en el body.
      const payload = { ...suc, region: suc.region || null, qr_token: suc.qr_token || null };
      sucursalService
        .update(payload)
        .then(() => this.makeToast("Guardado", "Sucursal " + suc.nombre + " actualizada", "success"))
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    qrUrl(token) {
      return this.qrBaseUrl.replace(/\/$/, "") + "/" + token;
    },
    errMsg(err) {
      if (err && err.response && err.response.data) {
        return typeof err.response.data === "string" ? err.response.data : (err.response.data.error || JSON.stringify(err.response.data));
      }
      return err && err.message ? err.message : "Error desconocido";
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, { title, variant, autoHideDelay: 5000, appendToast: true });
    },
  },
};
</script>
